/**
 * TanStack Router: /workforce/employees/$employeeId
 *
 * Employee details page route
 */
import { createFileRoute } from '@tanstack/react-router'
import EmployeeDetailsPage from '@/app/workforce/employees/[id]/page'

/**
 * Route: /workforce/employees/$employeeId
 * Layout: _auth (authenticated)
 * Component: EmployeeDetailsPage
 */
export const Route = createFileRoute('/_auth/workforce/employees/$employeeId/')({
  component: EmployeeDetailsPage,
})

